"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContainer = void 0;
var _reactRedux = require("react-redux");
var _authentication = require("../../../../actions/authentication");
var _flow = require("../../../../actions/flow");
var _login = require("../../../../actions/login");
var _registration = require("../../../../actions/registration");
var _state = require("../../../../actions/state");
var _view = require("../../../../actions/view");
var _selectors = require("./selectors");
var _autoFocusDisabled = require("../../../../selectors/autoFocusDisabled");
var _UsernameAuthFormContainer = require("./UsernameAuthFormContainer");
var _source = require("../../../../selectors/source");
function mapStateToProps(state) {
  return {
    isSubmitting: (0, _selectors.isFormSubmitting)(state),
    activeFlow: (0, _selectors.flowSelector)(state),
    submitButtonText: (0, _selectors.submitButtonTextSelector)(state),
    login: (0, _selectors.loginSelector)(state),
    loginError: (0, _selectors.loginErrorSelector)(state),
    isLoginInvalid: (0, _selectors.isLoginInvalidSelector)(state),
    hasAsyncLoginError: (0, _selectors.hasLoginErrorSelector)(state),
    password: (0, _selectors.passwordSelector)(state),
    passwordError: (0, _selectors.passwordErrorSelector)(state),
    isPasswordInvalid: (0, _selectors.isPasswordInvalidSelector)(state),
    hasAsyncPasswordError: (0, _selectors.hasPasswordErrorSelector)(state),
    hasAsyncPhoneError: (0, _selectors.hasPhoneErrorSelector)(state),
    phoneError: (0, _selectors.phoneErrorSelector)(state),
    autoFocusDisabled: (0, _autoFocusDisabled.selectAutoFocusDisabled)(state),
    isProfessionalUser: (0, _selectors.isProfessionalUserSelector)(state),
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    changeLogin(login) {
      dispatch((0, _login.changeLogin)(login));
    },
    changePassword(password) {
      dispatch((0, _authentication.changePassword)(password));
    },
    authenticate(params) {
      dispatch((0, _authentication.authenticate)(params));
    },
    register(params) {
      dispatch((0, _registration.register)(params));
    },
    checkEmail() {
      dispatch((0, _authentication.checkEmail)());
    },
    changeView(view, data) {
      dispatch((0, _view.changeView)(view, data));
    },
    changeFlow(flow) {
      dispatch((0, _flow.changeFlow)(flow));
    },
    resetToPhoneAuth() {
      dispatch((0, _state.resetToPhoneAuth)());
    },
    changeToPhoneAuth(phone) {
      dispatch((0, _state.changeToPhoneAuth)(phone));
    },
    changeIsProfessionalUser(value) {
      dispatch((0, _registration.professionalUserChange)(value));
    }
  };
}
const FormContainer = exports.FormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_UsernameAuthFormContainer.UsernameAuthFormContainer);